import { reqGet, reqDelete } from './axiosFun';

// 系统日志分页查询
export function sysLogPage(params) {
  return reqGet("/sys-log/page", params);
}

// 获取系统日志详情
export function getSysLog(id) {
  return reqGet(`/sys-log/${id}`);
}

// 删除系统日志
export function deleteSysLog(data) {
  return reqDelete("/sys-log", data);
}



// WEBPACK FOOTER //
// ./src/api/SysLog.js